import { render, staticRenderFns } from "./positionRuleTab.vue?vue&type=template&id=1292f7c6&scoped=true&"
import script from "./positionRuleTab.vue?vue&type=script&lang=js&"
export * from "./positionRuleTab.vue?vue&type=script&lang=js&"
import style0 from "./positionRuleTab.vue?vue&type=style&index=0&id=1292f7c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1292f7c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1292f7c6')) {
      api.createRecord('1292f7c6', component.options)
    } else {
      api.reload('1292f7c6', component.options)
    }
    module.hot.accept("./positionRuleTab.vue?vue&type=template&id=1292f7c6&scoped=true&", function () {
      api.rerender('1292f7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/tabPane/positionRuleTab.vue"
export default component.exports